import React from 'react';
import { connect } from 'react-redux';
import { ConnectedRouter, push } from 'connected-react-router';
import { Switch, Route } from 'react-router-dom';
import { Toast } from 'devextreme-react';
import { loginRoutes } from '../../config/routes';
import { fullScreenLoading, validateToken } from '../Acceso/Login/actions';
import { openCloseToast } from '../Global/actions';
import SolicitudesPendientes from '../SucursalVirtual/Trabajador/Solicitudes/SolicitudesPendientes/view';
import Header from '../Header/view';
import SucursalVirtual from '../SucursalVirtual';
import ToastCustom from '../Shared/ToastCustom';
import LoadingOverlayFullScreen from '../Shared/LoadingOverlayFullScreen';
import {
  getRouteIframe,
  isAuthenticated,
  isIframe,
  outsideSSOIframes,
  setRedirectionToInicio,
} from 'helpers/isIframe';
import Selection from 'components/Acceso/Selection/Selection';
import Redirection from 'components/Acceso/Redirection/Redirection';

class Main extends React.Component {
  constructor(props) {
    super(props);

    if (props.currentPath.indexOf('activarCuenta') === -1) {
      props.dispatch(validateToken());
    }
  }

  componentDidMount() {
    if (isIframe) {
      this.props.dispatch(fullScreenLoading(true));
      const route = getRouteIframe();
      window.intervalPersister = setInterval(() => {
        if (this.props.userAccessIds && this.props.userAccessIds.length && outsideSSOIframes()) {
          this.props.dispatch(push(route));
        } else if (
          this.props.userAccessIds &&
          this.props.userAccessIds.length &&
          !outsideSSOIframes()
        ) {
          this.props.dispatch(fullScreenLoading(false, true));
        }
        if (!isAuthenticated()) {
          setRedirectionToInicio();
        }
      }, 2000);
    }
  }

  componentWillUnmount() {
    clearInterval(window.intervalPersister);
  }

  closeToast = () => {
    const toast = {};
    toast.isToastOpen = false;

    this.props.dispatch(openCloseToast(toast));
  };

  render() {
    const LoginRoutes = (
      <ConnectedRouter history={this.props.history}>
        <Switch>
          {loginRoutes.map((route) => (
            <Route key={route.path} exact path={route.path} component={route.component} />
          ))}
        </Switch>
      </ConnectedRouter>
    );

    let body = <SucursalVirtual history={this.props.history} />;
    if (this.props.global.TempBD) {
      body = (
        <div style={{ overflowY: 'auto', height: '100%' }}>
          <Header height={60} menuWidth={0} />
          <div className='row zero justify-content-center' style={{ marginTop: 10 }}>
            <div className='col-10'>
              <SolicitudesPendientes />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className='zero container-fluid main-size' style={{ position: 'relative' }}>
        {this.props.isLoadingFullScreen && <LoadingOverlayFullScreen />}
        {!this.props.global.LoginSuccess && !this.props.isRedirected && LoginRoutes}
        {this.props.global.LoginSuccess &&
          this.props.canBeRedirected &&
          !this.props.isRedirected && <Selection />}
        {this.props.global.LoginSuccess &&
          !this.props.canBeRedirected &&
          !this.props.isRedirected &&
          body}
        {this.props.global.LoginSuccess && this.props.isRedirected && <Redirection />}
        <Toast
          visible={!!this.props.toast.isToastOpen}
          message={this.props.toast.msgToast ? this.props.toast.msgToast : ''}
          type={this.props.toast.typeStyle}
          displayTime={this.props.toast.displayTime || 90000}
          onOptionChanged={this.closeToast}
        />

        <ToastCustom />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentPath: state.router.location.pathname,
  data: state.login.data,
  global: state.global.userData,
  toast: state.global.toast,
  isLoadingFullScreen: state.login.isLoadingFullScreen,
  userAccessIds: state.global.userAccessIds,
  canBeRedirected: state.selection.canBeRedirected,
  isRedirected: state.selection.isRedirected,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Main);
